<ul class="options-menu" @openAnimation>
   <div (click)="setClose.emit(true)">
      <ng-container *ngTemplateOutlet="content"></ng-container>
   </div>
</ul>
